module.exports = __webpack_public_path__ + "img/4.b04f84d1.jpg";